import { render } from "./Segments.vue?vue&type=template&id=5e71d917&scoped=true&lang=pug"
import script from "./Segments.vue?vue&type=script&lang=js"
export * from "./Segments.vue?vue&type=script&lang=js"

import "./Segments.vue?vue&type=style&index=0&id=5e71d917&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e71d917"]])

export default __exports__